import React, { useState } from 'react';
import { 
  FolderOpen, FileText, Download, Search, AlertTriangle, Users, 
  BookOpen, Lock, Star, ClipboardList, Shield, HeartHandshake, 
  Brain, Compass, Megaphone 
} from 'lucide-react';

const MaterialsLibrary = ({ user, onUpgrade, triggerModal }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [activeTab, setActiveTab] = useState('Tümü'); // 🚀 YENİ: Aktif sekme state'i

  // 🚀 YENİ: PDR İş Akışına Uygun Sekmeler
  const TABS = [
    'Tümü', 
    'Matbu Evraklar', 
    'Plan ve Sözleşmeler', 
    'Kriz Yönetimi', 
    'Broşür & Psikoeğitim', 
    'Sunumlar'
  ];

  // PDR Uzmanlarının en çok ihtiyaç duyduğu matbu evraklar
  // Kategori (category) isimleri artık sekmelerle eşleşecek şekilde güncellendi
  const materials = [
    { id: 1, isPremium: false, category: 'Matbu Evraklar', title: 'Öğrenci Bireysel Görüşme Formu', desc: 'Rutin öğrenci görüşmelerinde kullanılacak standart kayıt formu.', icon: Users, color: 'text-blue-500', bg: 'bg-blue-50', fileUrl: '/docs/ogrenci_gorusme_formu.pdf' },
    { id: 2, isPremium: false, category: 'Matbu Evraklar', title: 'Veli Görüşme Kayıt Tutanağı', desc: 'Velilerle yapılan yüz yüze veya telefon görüşmelerini kayıt altına alma formu.', icon: Users, color: 'text-blue-500', bg: 'bg-blue-50', fileUrl: '/docs/veli_gorusme_formu.pdf' },
    { id: 3, isPremium: true, category: 'Kriz Yönetimi', title: 'Akran Zorbalığı Tespit ve Müdahale Formu', desc: 'Okul içi zorbalık durumlarında idare ve PDR servisi ortak tutanağı.', icon: AlertTriangle, color: 'text-red-500', bg: 'bg-red-50', fileUrl: '/docs/akran_zorbaligi_formu.pdf' },
    { id: 4, isPremium: true, category: 'Kriz Yönetimi', title: 'İhmal ve İstismar Şüphe Bildirim Formu', desc: 'Kritik yasal durumlarda yetkili mercilere bildirim için ön şablon.', icon: AlertTriangle, color: 'text-red-500', bg: 'bg-red-50', fileUrl: '/docs/istismar_bildirim_formu.pdf' },
    { id: 5, isPremium: true, category: 'Kriz Yönetimi', title: 'İntihar / Kendine Zarar Verme Risk Tutanağı', desc: 'Yüksek riskli vaka değerlendirme ve kriz yönetimi belgesi.', icon: AlertTriangle, color: 'text-red-500', bg: 'bg-red-50', fileUrl: '/docs/kriz_risk_tutanagi.pdf' },
    { id: 6, isPremium: true, category: 'Plan ve Sözleşmeler', title: 'Akademik Eylem Planı Öğrenci Sözleşmesi', desc: 'YKS/LGS sürecindeki öğrencilerle yapılan haftalık takip sözleşmesi.', icon: BookOpen, color: 'text-emerald-500', bg: 'bg-emerald-50', fileUrl: '/docs/akademik_eylem_plani.pdf' },
    { id: 7, isPremium: true, category: 'Plan ve Sözleşmeler', title: 'Teknoloji ve Ekran Kullanım Sözleşmesi', desc: 'Veli ve öğrenci arasında imzalanacak ekran süresi kısıtlama kontratı.', icon: BookOpen, color: 'text-emerald-500', bg: 'bg-emerald-50', fileUrl: '/docs/teknoloji_sozlesmesi.pdf' },
    { id: 8, isPremium: true, category: 'Plan ve Sözleşmeler', title: 'Aylık PDR Servisi Faaliyet Raporu Şablonu', desc: 'Okul müdürlüğüne sunulacak aylık rehberlik faaliyetleri özet tablosu.', icon: FileText, color: 'text-purple-500', bg: 'bg-purple-50' },
    { id: 9, isPremium: true, category: 'Matbu Evraklar', title: 'Sınıf Öğretmeni PDR Yönlendirme Formu', desc: 'Öğretmenlerin sorunlu davranışları PDR servisine standart bir veriyle raporlamasını sağlayan form.', icon: ClipboardList, color: 'text-teal-500', bg: 'bg-teal-50', fileUrl: '/docs/PDRservisineogrenciyonlendirmeformu.pdf' },
    { id: 10, isPremium: true, category: 'Plan ve Sözleşmeler', title: 'Öğrenci Davranış ve Uyum Sözleşmesi', desc: 'Disiplin süreci öncesi, öğrencinin kurallara uyacağına dair imzaladığı psikolojik akit.', icon: Shield, color: 'text-indigo-500', bg: 'bg-indigo-50', fileUrl: '/docs/ogrenci_davranis_sozlesmesi.pdf' },
    { id: 11, isPremium: true, category: 'Matbu Evraklar', title: 'Akran Çatışması Çözüm (Barış) Anlaşması', desc: 'Kavga eden veya anlaşamayan öğrencilerin arabuluculuk sonrası imzaladığı uzlaşma metni.', icon: HeartHandshake, color: 'text-amber-500', bg: 'bg-amber-50', fileUrl: '/docs/akran_catismasi_baris_anlasmasi.pdf' },
    { id: 12, isPremium: true, category: 'Broşür & Psikoeğitim', title: 'Sınav Kaygısı "İlk Yardım" Broşürü', desc: 'Kaygılı öğrenciye görüşme çıkışı teslim edilecek; nefes ve topraklama egzersizleri içeren el kağıdı.', icon: Brain, color: 'text-rose-500', bg: 'bg-rose-50', fileUrl: '/docs/sinav_kaygisi_ilk_yardim.pdf' },
    { id: 13, isPremium: true, category: 'Broşür & Psikoeğitim', title: 'Kariyer Keşif ve Meslek Araştırma Görevi', desc: 'Kararsız öğrencilere görüşme sonrasında verilen, 3 mesleği derinlemesine araştırma ödev formu.', icon: Compass, color: 'text-sky-500', bg: 'bg-sky-50', fileUrl: '/docs/meslek_arastirma_gorevi.pdf' },
    { id: 14, isPremium: true, category: 'Matbu Evraklar', title: 'Zor Veli İletişim Çerçevesi (Uzman Rehberi)', desc: 'İnkar eden veya suçlayıcı velilerle görüşürken PDR uzmanının masasında durması gereken taktik haritası.', icon: Megaphone, color: 'text-slate-600', bg: 'bg-slate-100', fileUrl: '/docs/zor_velilerle_gorusme.pdf' },
  ];

  // 🚀 YENİ: Hem arama terimine hem de seçili sekmeye göre filtreleme motoru
  const filteredMaterials = materials.filter(m => {
    const matchSearch = m.title.toLowerCase().includes(searchTerm.toLowerCase()) || m.desc.toLowerCase().includes(searchTerm.toLowerCase());
    const matchTab = activeTab === 'Tümü' ? true : m.category === activeTab;
    return matchSearch && matchTab;
  });

  const handleDownload = (item) => {
    if (item.isPremium && !user?.isPremium) {
      triggerModal({
        type: 'confirm',
        title: '🔒 Premium Doküman',
        message: `"${item.title}" sadece Premium üyelere özel bir dokümandır.\n\nTüm dokümanlara, sınırsız yapay zeka analizine ve kurumsal raporlara erişmek için Premium'a geçmek ister misiniz?`,
        confirmText: 'Premium İncele',
        onConfirm: () => {
          if (onUpgrade) onUpgrade(); 
        }
      });
      return;
    }

    if (item.fileUrl) {
      const link = document.createElement("a");
      link.href = item.fileUrl;
      link.download = item.fileUrl.split('/').pop(); 
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      triggerModal({
        type: 'alert',
        title: 'Hazırlanıyor',
        message: `"${item.title}" dokümanı şu an hazırlanma aşamasındadır. Çok yakında sisteme yüklenecektir!`
      });
    }
  };

  return (
    <div className="p-6 md:p-10 max-w-7xl mx-auto animate-in fade-in duration-500">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-6">
        <div>
          <h2 className="text-3xl font-black text-slate-800 flex items-center tracking-tight">
            <FolderOpen className="h-8 w-8 mr-3 text-blue-600" />
            PDR Dijital Çantası
          </h2>
          <p className="text-slate-500 font-medium mt-2">Mesleki hayatınızda ihtiyaç duyduğunuz tüm matbu evraklar ve şablonlar tek tık uzağınızda.</p>
        </div>
        
        {/* Arama Çubuğu */}
        <div className="relative w-full md:w-80">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
          <input 
            type="text" 
            placeholder="Doküman ara..." 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-3 rounded-xl border border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all shadow-sm"
          />
        </div>
      </div>

      {/* 🚀 YENİ: Yatay Kaydırılabilir Sekme Çubuğu */}
      <div className="flex overflow-x-auto gap-3 pb-4 mb-6 custom-scrollbar hide-scrollbar-on-mobile">
        {TABS.map(tab => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-5 py-2.5 rounded-xl font-bold text-sm whitespace-nowrap transition-all shadow-sm border
              ${activeTab === tab 
                ? 'bg-blue-600 text-white border-blue-600 shadow-blue-200' 
                : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50 hover:border-slate-300'}`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-6">
        {filteredMaterials.length > 0 ? filteredMaterials.map((item) => {
          
          const isLocked = item.isPremium && !user?.isPremium;

          return (
            <div key={item.id} className={`bg-white rounded-2xl border p-6 shadow-sm transition-all duration-300 group flex flex-col relative overflow-hidden ${isLocked ? 'border-slate-200' : 'border-slate-200 hover:shadow-md hover:border-blue-300'}`}>
              
              {item.isPremium && (
                <div className="absolute top-4 right-4 bg-gradient-to-r from-amber-400 to-yellow-500 text-yellow-950 text-[9px] font-black px-2 py-1 rounded-md uppercase tracking-widest flex items-center shadow-sm z-10">
                  <Star className="h-3 w-3 mr-1 fill-current" /> PRO
                </div>
              )}

              <div className="flex items-start justify-between mb-4 mt-2">
                <div className={`h-12 w-12 rounded-xl flex items-center justify-center ${item.bg} ${item.color} ${!isLocked && 'group-hover:scale-110'} transition-transform`}>
                  <item.icon className="h-6 w-6" />
                </div>
                {/* Etiketi aktif sekmeye tıklanabilir gibi göstermek yerine sadece kategori bilgisi olarak veriyoruz */}
                <span className="text-[10px] font-bold uppercase tracking-widest text-slate-400 bg-slate-100 px-3 py-1 rounded-full mt-1">
                  {item.category}
                </span>
              </div>
              
              <h3 className={`font-bold text-lg mb-2 line-clamp-2 ${isLocked ? 'text-slate-600' : 'text-slate-800'}`}>{item.title}</h3>
              <p className={`text-sm mb-6 flex-1 line-clamp-3 ${isLocked ? 'text-slate-400' : 'text-slate-500'}`}>{item.desc}</p>
              
              <button 
                onClick={() => handleDownload(item)}
                className={`w-full flex items-center justify-center py-3 border rounded-xl font-bold text-sm transition-colors mt-auto
                  ${isLocked 
                    ? 'bg-slate-100 text-slate-500 border-slate-200 hover:bg-slate-200' 
                    : 'bg-slate-50 hover:bg-blue-50 text-slate-700 hover:text-blue-700 border-slate-200 hover:border-blue-200'
                  }`}
              >
                {isLocked ? (
                  <>
                    <Lock className="h-4 w-4 mr-2" />
                    Premium Gerekli
                  </>
                ) : (
                  <>
                    <Download className="h-4 w-4 mr-2" />
                    Şablonu İndir
                  </>
                )}
              </button>
            </div>
          );
        }) : (
          <div className="col-span-full py-20 text-center bg-white rounded-3xl border border-slate-200 border-dashed">
            <FileText className="h-16 w-16 mx-auto text-slate-300 mb-4" />
            <h3 className="text-xl font-bold text-slate-600 mb-2">Doküman Bulunamadı</h3>
            <p className="text-slate-400">Bu kategoride veya arama kriterinize uygun bir evrak şablonu henüz bulunmuyor.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MaterialsLibrary;